import React from "react";
import Hero from "../components/Hero";
import Infrastructure from "../components/Infrastructure";
import Livestock from "../components/Livestock";
import MarketingValue from "../components/MarketingValue";
import Process from "../components/Process";

const Home = () => {
  const BrownDivider = () => (
    <div className="w-full h-[8px] bg-[#4B3621]" />
  );

  return (
    <div className="flex flex-col space-y-0 overflow-hidden bg-[#FDFCF8]">
      <Hero />
      
      <Infrastructure />
      <BrownDivider />
      
      <Livestock />
      <BrownDivider />
      
      <MarketingValue />
      <BrownDivider />
      
      <Process />
    </div>
  );
};

export default Home;